import { P2GBox, P2GDivider, P2GGrid, P2GText } from '@parcel2go/core-ui';
import { TranslationNamespaces } from '~/lib/constants';
import { Trans, useTranslation } from 'react-i18next';

export default function QuoteResultHeading({
  translationKey,
  defaultValue,
  values,
  components,
  children,
  adornment
}: {
  translationKey: string;
  defaultValue: string;
  values?: { [key: string]: string | number };
  components?: JSX.Element[];
  adornment?: JSX.Element;
  children?: React.ReactNode;
}) {
  const { t } = useTranslation([TranslationNamespaces.QUOTE]);

  return (
    <P2GGrid container gap={3} direction="column">
      <P2GGrid item>
        <P2GBox display="flex" alignItems="center" gap={2}>
          {adornment && <span>{adornment}</span>}
          <P2GText variant="h2">
            <Trans i18nKey={translationKey} t={t} defaults={defaultValue} values={values} components={components} />
          </P2GText>
        </P2GBox>
      </P2GGrid>
      <P2GGrid item>
        <P2GDivider />
      </P2GGrid>
      {children && <P2GGrid item>{children}</P2GGrid>}
    </P2GGrid>
  );
}
